import { deleteElement, fetchElements, saveElementsType, updateElement } from "@/lib/utils";
import type { IndicadoresMunicipio, ValoresMunicipio } from "@/types/models/indicadores";
import type { IndicadoresMunicipioRepository } from "@/lib/repositories/interfaces/indicadores-repository.interface";

const INDICADORES_FIELDS = ["*", "translations.*"] as const;
const VALORES_FIELDS = ["*"] as const;

export const indicadoresMunicipioRepository: IndicadoresMunicipioRepository = {
  fetchIndicadoresByTenant: (tenantId: number) =>
    fetchElements<IndicadoresMunicipio>("indicadores_municipio", [...INDICADORES_FIELDS], undefined, { tenant: { _eq: tenantId } }),

  fetchValoresByTenant: (tenantId: number) =>
    fetchElements<ValoresMunicipio>("valores_municipio", [...VALORES_FIELDS], undefined, { indicador: { tenant: { _eq: tenantId } } }),

  fetchValoresByIndicador: (indicadorId: number) =>
    fetchElements<ValoresMunicipio>("valores_municipio", [...VALORES_FIELDS], undefined, { indicador: { _eq: indicadorId } }),

  createIndicador: async (payload: Partial<IndicadoresMunicipio>) =>
    (await saveElementsType<IndicadoresMunicipio>("indicadores_municipio", [payload]))[0],

  updateIndicador: (id: number, changes: Partial<IndicadoresMunicipio>) =>
    updateElement("indicadores_municipio", id, changes),

  deleteIndicador: (id: number) =>
    deleteElement("indicadores_municipio", id),

  createValores: (payloads: Partial<ValoresMunicipio>[]) =>
    payloads.length ? saveElementsType<ValoresMunicipio>("valores_municipio", payloads) : Promise.resolve([]),

  updateValor: (id: number, changes: Partial<ValoresMunicipio>) =>
    updateElement("valores_municipio", id, changes),

  deleteValor: (id: number) =>
    deleteElement("valores_municipio", id),
};
